module.exports = __webpack_public_path__ + "img/small-arrow-left.17a21423.svg";